import {
  getIconProperties
} from "../chunks/chunk.OVBRLX5Z.js";
import "../chunks/chunk.K2NRSETB.js";
export {
  getIconProperties
};
